module.exports = __webpack_public_path__ + "img/icon-xls.baffe61d.svg";